import { render, staticRenderFns } from "./ManagerJobsList.vue?vue&type=template&id=37eb1fe4&scoped=true"
import script from "./ManagerJobsList.vue?vue&type=script&lang=js"
export * from "./ManagerJobsList.vue?vue&type=script&lang=js"
import style0 from "./ManagerJobsList.vue?vue&type=style&index=0&id=37eb1fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eb1fe4",
  null
  
)

export default component.exports